/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react'

import { Flex, Image } from 'lese'
import Select from 'react-select'
import { Button } from 'Components/shared/Button'
import TextArea from 'Components/shared/TextArea'

import { ModalCard, closeModal } from 'Components/Modal'

import styled from '@emotion/styled'

import MessageTemplateService from 'Services/message-templates'

import MessagesService from 'Services/messages'
import { toastWithErrorMessage } from 'Helpers/toast'
import { toast } from 'react-toastify'
import { colors } from 'Constants'

export const MessageImage = styled(Image)`
  cursor: pointer;
  margin-right: 30px;
  width: 30px;
  height: 30px;
`

const SelectContainer = styled(Flex)`
  grid-column: 1;
  padding: 16px;
  width: 600px;
`

const SelectMessage = styled(Select)`
  width: 100%;
`

const textAreaStyle = {
  padding: '0.5em 0.2em'
}

export default ({ tCode }) => {
  const [activeTemplate, setActiveTemplate] = useState(undefined)
  const [templates, setTemplates] = useState()
  const [templateNames, setTemplateNames] = useState([{ label: 'Error' }])

  // Get all the titles of the templates that are pulled for the app code
  function getTemplateTitles(temps) {
    if (temps === undefined || temps === 'OK' || temps?.length === 0)
      return [{ text: 'No templates found' }] // Check to make sure we got templates

    const arr = []
    temps.forEach(temp => {
      arr.push({ label: temp.viewTitle, value: temp.id })
    })

    return arr
  }

  // Update the active template
  const updateTemplate = async ({ value }) => {
    const index = templates.findIndex(template => template.id === value)
    if (index === -1) toastWithErrorMessage('Did not find the selected message template')
    else setActiveTemplate(templates[index])
  }

  const sendMessage = async () => {
    const { title, body, link, categoryId } = activeTemplate
    let splittCode = tCode

    if (splittCode.split('').includes('-')) [splittCode] = splittCode.split('-')

    MessagesService.sendMessage({
      tCode: splittCode,
      messageTitle: title,
      messageBody: body,
      link,
      categoryId
    })
      .catch(err => {
        toastWithErrorMessage(err)
      })
      .then(() => {
        toast.success(`Send message to T-Code: ${tCode}`)
        closeModal()
      })
  }

  useEffect(async () => {
    // Get the templates and update the states and titles
    const fetchedTemplates = await MessageTemplateService.get({ tCode })
    setTemplates(fetchedTemplates)
    setTemplateNames(await getTemplateTitles(fetchedTemplates))
  }, [tCode])

  let link
  if (activeTemplate) {
    link = activeTemplate.link ? activeTemplate?.link : 'No link specified'
  }

  return (
    <ModalCard style={{ overflow: 'hidden' }}>
      <Flex separation="24px" padding="2em" column>
        <SelectContainer xAlign="space-between" yAlign="center" style={{ alignSelf: 'center' }}>
          <SelectMessage
            options={templateNames}
            selected={activeTemplate}
            onChange={updateTemplate}
          />
        </SelectContainer>
        <hr width="100%" />
        <div>
          <label htmlFor="title">Message that appears on the phone</label>
          <TextArea
            name="title"
            width="100%"
            cols="auto"
            rows="auto"
            resize="none"
            readOnly
            style={textAreaStyle}
          >
            {activeTemplate?.title}
          </TextArea>
        </div>
        <div>
          <label htmlFor="body">Body</label>
          <TextArea
            name="body"
            width="100%"
            cols="auto"
            rows="auto"
            resize="none"
            readOnly
            style={textAreaStyle}
          >
            {activeTemplate?.body}
          </TextArea>
        </div>
        <div>
          <label htmlFor="link">Link</label>
          <TextArea
            name="link"
            width="100%"
            cols="auto"
            rows="auto"
            resize="none"
            readOnly
            style={textAreaStyle}
          >
            {link}
          </TextArea>
        </div>
        <Flex yAlign="center" xAlign="center" separation="2em">
          <Button
            style={{ margin: '1em' }}
            onClick={() => {
              if (activeTemplate) {
                sendMessage()
              }
            }}
            disabled={!activeTemplate}
          >
            Send
          </Button>
          <Button style={{ margin: '1em' }} onClick={() => closeModal()} color={colors.blue}>
            Cancel
          </Button>
        </Flex>
      </Flex>
    </ModalCard>
  )
}
